import React from 'react';
import { useDispatch } from 'react-redux';

import { Logo } from '@interlayer/js/app/components/common/Logo';
import { I18n } from '@interlayer/js/components/common/I18n';

import { useTranslations } from '@core/js/hooks/i18n';

import { useStepNumber } from '@interlayer/js/app/components/main/Registration/hooks/storeData/useStepNumber';
import { useNavigateToHome } from '@interlayer/js/app/hooks/navigate/useNavigateToHome';
import { setIsShowClosePopup } from '@interlayer/js/app/store/reducers/Registration/actions';

import style from '@interlayer/js/app/components/main/DefaultMenu/components/MenuDesktop/MenuDesktop.scss';

export const EmptyMenu: React.FC = () => {
    const dispatch = useDispatch();
    const stepNumber = useStepNumber();
    const navigateToHome = useNavigateToHome();
    const t = useTranslations('playtech.mobile.system.header.');

    const handlerBackHome = () => {
        if (stepNumber === 0) {
            navigateToHome();
            return;
        }

        dispatch(setIsShowClosePopup(true));
    };

    return (
        <div className={style.containerWithoutMenu}>
            <div className={style.wrap}>
                <Logo
                    size="3.4rem"
                    className={style.logo}
                    onClick={handlerBackHome}
                />

                <span
                    className={style.takeMeBackHome}
                    onClick={handlerBackHome}
                >
                    <I18n t={t} tKey="takeMeBackHome" />
                </span>
            </div>
        </div>
    );
};
